<template>
    <header-mobile></header-mobile>
    <div id="body">
        <div id="background-modal" :class="{ activeBackground: isActive }">
            <div class="row">
                <div id="modal" :class="{ active: isActive }">
                    <span style="float:left;font-size:1.5em;font-weight:bold;margin-top:35px;"> &nbsp; Detail Manifest Kurir</span>
                    <span class="xmarks" @click="closeModal">
                        <font-awesome-icon :icon="['fas', 'xmark']" style="cursor:pointer;"/>
                    </span>
                    <div class="both"></div>
                    <div class="content-modal">
                        <table width="100%" class="table table-row-dashed table-row-gray-300 gy-7">
                            <tr>
                                <td width="30%">No Manifest</td>
                                <td width="1%">:</td>
                                <td>{{ detailModal.no_manifest }}</td>
                            </tr>
                            <tr>
                                <td width="30%">Total Tagihan</td>
                                <td width="1%">:</td>
                                <td>{{ rupiahs(detailModal.total_price_cod) }}</td>
                            </tr>
                            <tr>
                                <td width="30%">Tanggal Buat</td>
                                <td width="1%">:</td>
                                <td>{{ detailModal.create_date }}</td>
                            </tr>
                            <tr>
                                <td width="30%">Tanggal Verif</td>
                                <td width="1%">:</td>
                                <td>{{ detailModal.verified_date }}</td>
                            </tr>
                            <tr>
                                <td width="30%">Status</td>
                                <td width="1%">:</td>
                                <td>{{ detailModal.status }}</td>
                            </tr>
                        </table>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-12">
                <breadcrumbs-mobile :breadcrumbItem="breadcrumbs" to="/dashboard"></breadcrumbs-mobile>
                <div class="card" style="min-height:200px;">
                    <div class="card-body">
                        <font-awesome-icon icon="fa-solid fa-list-ul" class="icon-list" /><span style="font-size:1.5em;font-weight:bold;"> &nbsp; List Manifest Kurir</span>
                        <div id="search">
                            <input type="text" class="form-control" v-model="searchForm"  placeholder="Cari Manifest..." style="margin-top:20px;padding-right:110px;font-size:1.5em;"/>
                            <button class="button-search" @click="processSearching()" :disabled="searchAction"> <font-awesome-icon icon="fa-solid fa-magnifying-glass" id="search-icon" v-if="searchAction == false"/> <img style="max-width:100%;" src="../assets/media/apps/loading2.gif" v-else/></button>
                        </div>
                        <loading-mobile v-if="loadingManifestCourier == true"></loading-mobile>
                        <div id="list-invoice" v-else-if="manifest_courier.length > 0">
                            
                            <div class="table-responsive">
                                <table class="table table-row-dashed table-row-gray-300 gy-7">
                                    <thead>
                                        <tr class="fw-bolder fs-6 text-gray-800">
                                            <th>No</th>
                                            <th class="no-break">No. Manifest Kurir</th>
                                            <th>Status</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(strc, index) in manifest_courier" :key="strc.no_manifest" @click="showModal(strc.no_manifest, strc.create_date, strc.last_update, strc.total_price_cod, strc.status_manifest)">
                                            <td>{{ index + 1 }}</td>
                                            <td class="no-break">{{ strc.no_manifest }}</td>
                                            <td>
                                                <span v-if="strc.status_manifest == 'tagihan'" class="badge badge-danger" style="text-transform:capitalize;font-size:0.8em;">{{ strc.status_manifest }}</span>
                                                <span v-else class="badge badge-success" style="text-transform:capitalize;font-size:0.8em;">{{ strc.status_manifest }}</span>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                            <!-- <loading-mobile v-if="showLoadMore == true"></loading-mobile> -->
                        </div>
                        <div id="not-found" class="text-center" v-else>
                            <img src="../assets/media/apps/not-found.png" alt="not-found-img"/>
                            <div style="font-size:1.5em;">Tagihan Tidak Ditemukan</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <nav-bar></nav-bar>
</template>
<script>
import HeaderMobile from './HeaderMobile.vue'
import NavBar from './NavBar.vue'
import BreadcrumbsMobile from './BreadcrumbsMobile.vue'
import LoadingMobile from './LoadingMobile.vue'
import api from '../api'
import { toast } from 'vue3-toastify'

export default {
    name: 'ManifestCourier',
    components: {
        HeaderMobile,
        NavBar,
        BreadcrumbsMobile,
        LoadingMobile
    },
    data(){
        return{
            manifest_courier : [],
            breadcrumbs : ['Home', 'Manifest Courier'],
            loadingManifestCourier: false,
            // showLoadMore : false,
            // offset : 0,
            // limitLoad : false,
            searchForm : "",
            searchAction: false,
            isActive : false,
            detailModal : {
                no_manifest : "",
                create_date : "",
                verified_date : "",
                total_price_cod : "",
                status : ""
            }
        }
    },
    methods:{
        refresh(){
            this.loadingManifestCourier = true
            // this.limitLoad = false
            api.post("list_manifest_sapx",{
                params :{
                    "token": localStorage.getItem('token')
                    // "offset": 0
                }
            }).then((response) => {
            if(response.data.alert == 'success'){
                this.manifest_courier = response.data.data.manifest
                this.loadingManifestCourier = false
                // this.offset = response.data.data.offset
               
            }else if(response.data.alert == 'relog'){
                localStorage.removeItem("token")
                this.$router.push("/")
            }else{
                toast(response.data.msg, {
                    autoClose: 3000,
                    theme: "light",
                    type: "error",
                    pauseOnHover: false,
                    position: "top-right",
                    multiple: false
                })
                this.loadingManifestCourier = false
            }
            }).catch(function () {
                // this.loadingManifestCourier = false
                toast("Masalah Jaringan", {
                    autoClose: 3000,
                    theme: "light",
                    type: "error",
                    pauseOnHover: false,
                    position: "top-right",
                    multiple: false
                })
            })
        },
        // loadMore(){
        //     if(this.limitLoad == false){
        //         api.get("list_manifest_sapx",{
        //             params :{
        //                 "token": localStorage.getItem('token'),
        //                 "offset": this.offset
        //             }
        //         }).then((response) => {
        //         if(response.data.alert == 'success'){
        //             for(let i = 0; i < response.data.data.manifest.length; i++){
        //                 this.manifest_courier.push(response.data.data.manifest[i])
        //             }
        //             this.offset = response.data.data.offset
        //             this.showLoadMore = false
        //         }else if(response.data.alert == 'relog'){
        //             localStorage.removeItem("token")
        //             localStorage.removeItem("name")
        //             this.$router.push("/")
        //         }else if(response.data.alert == 'no more load'){
        //             this.limitLoad = true
        //             this.showLoadMore = false
        //         }else{
        //             this.showLoadMore = false
        //             toast(response.data.msg, {
        //                 autoClose: 3000,
        //                 theme: "light",
        //                 type: "error",
        //                 pauseOnHover: false,
        //                 position: "top-right",
        //                 multiple: false
        //             })
                    
        //         }
        //         }).catch(function () {
        //             this.showLoadMore = false
        //             toast("Masalah Jaringan", {
        //                 autoClose: 3000,
        //                 theme: "light",
        //                 type: "error",
        //                 pauseOnHover: false,
        //                 position: "top-right",
        //                 multiple: false
        //             })
        //         })
        //     }
        // },
        processSearching(){
            let form = this.searchForm
            this.searchAction = true
            if(form.length == 0){
                this.refresh()
                this.searchAction = false
            }else{
                this.limitLoad = true
                this.loadingManifestCourier = true
                api.post("search_sapx",{
                    params :{
                        "token": localStorage.getItem('token'),
                        "no_manifest": form
                    }
                }).then((response) => {
                if(response.data.alert == 'success'){
                    this.manifest_courier = response.data.data.manifest
                    this.loadingManifestCourier = false
                    this.searchAction = false
                }else if(response.data.alert == 'relog'){
                    localStorage.removeItem("token")
                    this.$router.push("/")
                }else{
                    this.manifest_courier = []
                    this.loadingManifestCourier = false
                    this.searchAction = false
                }
                }).catch(function () {
                    toast("Masalah Jaringan", {
                        autoClose: 3000,
                        theme: "light",
                        type: "error",
                        pauseOnHover: false,
                        position: "top-right",
                        multiple: false
                    })
                })                
            }
        },
        showModal(no_manifest, create_date, last_update, total_price_cod, status){
            this.isActive = true
            this.detailModal.no_manifest = no_manifest
            this.detailModal.create_date = create_date
            this.detailModal.verified_date = last_update
            this.detailModal.total_price_cod = total_price_cod
            this.detailModal.status = status
        },
        closeModal(){
            this.isActive = false
        },
        rupiahs(number){
            let number_string = number.toString(),
            split   		= number_string.split(','),
            sisa     		= split[0].length % 3,
            rupiah     		= split[0].substring(0, sisa),
            ribuan     		= split[0].substring(sisa).match(/\d{3}/gi),
            separator       = ''
        
            
            if(ribuan){
                separator = sisa ? '.' : '';
                rupiah += separator + ribuan.join('.')
            }
        
            rupiah = split[1] != undefined ? rupiah + ',' + split[1] : rupiah
            return (rupiah ? 'Rp. ' + rupiah : '')
        }
    },
    mounted(){
        let obj = this
        obj.refresh()
        // window.onscroll = function() {
        //     if ((window.innerHeight + window.scrollY) >= document.documentElement.scrollHeight) {
        //         if(obj.showLoadMore == false && obj.limitLoad == false){
        //             obj.showLoadMore = true
        //             setTimeout(function(){
        //                 obj.loadMore()
        //             }, 1000)
        //         }
        //     }
        // }
    }
}
</script>
<style scoped>
#search{
    position:relative;
}
#search-icon{
    color:#fff;
    font-size:1.5em;
}
.button-search{
    background:#A61F69;
    height:100%;
    width:50px;
    position:absolute;
    right:0;
    top:0;
    border:none;
    border-top-right-radius: 5px 5px;
    border-bottom-right-radius: 5px 5px;
}
.button-search focus{
    outline: none;
}

#background-modal{
    position:fixed;
    padding:0;
    margin:0;
    width:100%;
    height:100vh;
    z-index: -10;
    top:0;
    left:0;
    background:rgba(0,0,0,.5);
    opacity:0;
}
#background-modal.activeBackground{
    z-index:999;
    opacity:1;
}
#modal{
    position: fixed;
    background:#fff;
    width:100%;
    height:75%;
    z-index: 99999;
    left:0;
    bottom:-100%;
    border-top-left-radius: 30px 30px;
    border-top-right-radius: 30px 30px;
    transition: bottom 0.2s ease-out;
}
#modal.active {
  bottom: 0;
}
#modal.close {
  bottom: -100%;
}
.xmarks{
    float:right;
    margin-right:20px;
    margin-top:20px;
    font-size:3em;
}
.content-modal{
    padding:10px;
}

</style>
